import { render, staticRenderFns } from "./consultants.vue?vue&type=template&id=94ba710e&"
import script from "./consultants.vue?vue&type=script&lang=js&"
export * from "./consultants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports